import { Slide, Fade } from 'react-awesome-reveal';
import {
  FaTwitterSquare, FaFacebookSquare, FaLinkedin, FaGithubSquare,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Profile from '../images/profile.png';

const Home = () => {
  useEffect(() => {
    const img = document.querySelector('.home-profile');
    const move = (e) => {
      const x = e.pageX - img.offsetLeft - img.offsetWidth / 2;
      const y = e.pageY - img.offsetTop - img.offsetHeight / 2;
      const xPourcent = (x * 100) / (img.offsetWidth);
      const yPourcent = (y * 100) / (img.offsetHeight);
      img.style.willChange = 'transform';
      img.style.transform = `perspective(1000px) rotateX(${-yPourcent}deg) rotateY(${xPourcent}deg) scale3d(1, 1, 1)`;
    };

    const reinit = () => {
      setTimeout(() => {
        img.style.transform = '';
      }, 200);
    };

    img.addEventListener('mousemove', move);
    img.addEventListener('mouseleave', reinit);
  }, []);

  return (
    <Slide direction="left">
      <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
        <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-10  overflow-y-scroll">
          <div className="flex w-full responsive-home">
            <div className="w-5/12 px-5 flex">
              <div className="home-profile">
                <img alt="Aime Malaika" src={Profile} className="home-profile-img" loading="lazy" />
              </div>
            </div>
            <div className="w-7/12 px-5">
              <Fade direction="down" cascade delay={500}>
                <p className="text-slate-400 text-lg text-center">Get to know me </p>
                <h1 className="text-black dark:text-white font-bold text-center text-5xl my-8 name-on-home">Aime Malaika</h1>
                <div className="animated-bar" />
              </Fade>
              <div className="animated-text">
                <h3 className="main-color my-3 font-semibold text-center text-4xl">Web Developer</h3>
                <h3 className="main-color my-3 font-semibold text-center text-4xl">UI - UX Designer</h3>
                <h3 className="main-color my-3 font-semibold text-center text-4xl">Software Engineer</h3>
              </div>
              <Fade direction="down" cascade delay={500}>
                <div className="social-icons">
                  <ul className="flex justify-center">
                    <li className="px-2.5">
                      <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://twitter.com/Aime_Malaika">
                        <FaTwitterSquare />
                      </a>
                    </li>
                    <li className="px-2.5">
                      <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.facebook.com/aime.malaikamichaelange">
                        <FaFacebookSquare />
                      </a>
                    </li>
                    <li className="px-2.5">
                      <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.linkedin.com/in/aimemalaika">
                        <FaLinkedin />
                      </a>
                    </li>
                    <li className="px-2.5">
                      <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://github.com/aimemalaika">
                        <FaGithubSquare />
                      </a>
                    </li>
                  </ul>
                </div>
                <p className="my-10 text-center text-slate-400">
                  I am a results-driven software developer from Rwanda,
                  skilled at turning complex ideas into seamless,
                  user-friendly solutions. With strong fintech and event
                  tech experience, I deliver fast, reliable, and impactful
                  products that drive real business value.
                </p>
                <div className="flex justify-center">
                  <button className="button-style" type="button">Hire Me</button>
                  <Link className="button-style" to="/about">About Me</Link>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default Home;
